import Vue from 'vue'
import Router from 'vue-router'

import PageNotFound from '@/views/PageNotFound.vue'
import SignIn from '@/views/SignIn.vue'
import Search from '@/views/Search.vue'
import Ads from '@/views/Ads.vue'
import UserSearch from '@/modules/users/UserSearch.vue'
import UserModule from '@/modules/users/UserModule.vue'
import User from '@/modules/users/User.vue'
import HuntAreaModule from '@/modules/huntareas/HuntAreaModule.vue'
import HuntModule from '@/modules/hunts/HuntModule.vue'
import UserHuntArea from '@/modules/users/UserHuntArea.vue'
import UserHunt from '@/modules/users/UserHunt.vue'
import UserGPS from '@/modules/users/UserGPS.vue'
import UserWeHuntGPS from '@/modules/users/UserWeHuntGPS.vue'
import GPSDevicesSearch from '@/modules/gps/GPSDevicesSearch.vue'
import WeHuntGPSModule from '@/modules/gps/WeHuntGPSModule.vue'
import WeHuntGPS from '@/modules/gps/WeHuntGPS.vue'
import GPSDeviceModule from '@/modules/gps/GPSDeviceModule.vue'
import GPSDevice from '@/modules/gps/GPSDevice.vue'
import HuntAreasSearch from '@/modules/huntareas/HuntAreasSearch.vue'
import HuntArea from '@/modules/huntareas/HuntArea.vue'
import GamecamsSearch from '@/modules/gamecams/GamecamsSearch.vue'
import GamecamModule from '@/modules/gamecams/GamecamModule.vue'
import Gamecam from '@/modules/gamecams/Gamecam.vue'
import AdsSidebar from '@/modules/ads/AdsSidebar.vue'
import AdDetails from '@/modules/ads/AdDetails.vue'

import animalsRoutes from '@/modules/animals/animalsRoutes'
import resourcesRoutes from '@/modules/resources/resourcesRoutes'

import { USERS_CACHE_NAMESPACE, HUNT_AREAS_CACHE_NAMESPACE } from './store'

import {
  USERS_SEARCH_STORE_NAMESPACE,
  SELECTED_USER_STORE_NAMESPACE,
  SELECTED_HUNT_AREA_NAMESPACE,
  SELECTED_HUNT_NAMESPACE,
  USER_SELECTED_WEHUNT_GPS_DEVICE_STORE_NAMESPACE,
  USER_SELECTED_GPS_DEVICE_STORE_NAMESPACE
} from '@/modules/users/usersSearchStore'

import {
  GPS_DEVICES_SEARCH_STORE_NAMESPACE,
  SELECTED_WEHUNT_GPS_DEVICE_STORE_NAMESPACE,
  SELECTED_GPS_DEVICE_STORE_NAMESPACE
} from '@/modules/gps/gpsDevicesSearchStore'

import {
  HUNT_AREAS_SEARCH_STORE_NAMESPACE,
  SELECTED_HUNT_AREA_STORE_NAMESPACE
} from '@/modules/huntareas/huntAreasSearchStore'

import { GAMECAMS_SEARCH_STORE_NAMESPACE } from '@/modules/gamecams/gamecamStore'

import { ADS_STORE_NAMESPACE } from '@/modules/ads/adsStore'

const USERS_SEARCH_SELECTED_USER_STORE_PATH = `${USERS_SEARCH_STORE_NAMESPACE}/${SELECTED_USER_STORE_NAMESPACE}`
const USERS_SEARCH_SELECTED_USER_HUNT_AREA_STORE_PATH = `${USERS_SEARCH_STORE_NAMESPACE}/${SELECTED_HUNT_AREA_NAMESPACE}`
const USERS_SEARCH_SELECTED_USER_HUNT_STORE_PATH = `${USERS_SEARCH_STORE_NAMESPACE}/${SELECTED_HUNT_NAMESPACE}`
const USERS_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH = `${USERS_SEARCH_STORE_NAMESPACE}/${USER_SELECTED_WEHUNT_GPS_DEVICE_STORE_NAMESPACE}`
const USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH = `${USERS_SEARCH_STORE_NAMESPACE}/${USER_SELECTED_GPS_DEVICE_STORE_NAMESPACE}`

const GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH = `${GPS_DEVICES_SEARCH_STORE_NAMESPACE}/${SELECTED_WEHUNT_GPS_DEVICE_STORE_NAMESPACE}`
const GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH = `${GPS_DEVICES_SEARCH_STORE_NAMESPACE}/${SELECTED_GPS_DEVICE_STORE_NAMESPACE}`

const HUNT_AREAS_SEARCH_SELECTED_HUNT_AREA_STORE_PATH = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${SELECTED_HUNT_AREA_STORE_NAMESPACE}`

Vue.use(Router)

const routes = [
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  },
  {
    path: '/search',
    name: 'search',
    component: Search,

    children: [
      {
        path: 'users',
        name: 'usersSearch',
        components: {
          master: UserSearch
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedUserStorePath: USERS_SEARCH_SELECTED_USER_STORE_PATH,
            selectedHuntAreaStorePath: USERS_SEARCH_SELECTED_USER_HUNT_AREA_STORE_PATH,
            selectedHuntStorePath: USERS_SEARCH_SELECTED_USER_HUNT_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE,
            huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE,
            weHuntGPSStorePath: USERS_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
            gpsDeviceStorePath: USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH
          })
        }
      },
      {
        path: 'users/:userId',

        components: {
          master: UserSearch,
          details: UserModule
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedUserStorePath: USERS_SEARCH_SELECTED_USER_STORE_PATH,
            selectedHuntAreaStorePath: USERS_SEARCH_SELECTED_USER_HUNT_AREA_STORE_PATH,
            selectedHuntStorePath: USERS_SEARCH_SELECTED_USER_HUNT_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE,
            huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE,
            weHuntGPSStorePath: USERS_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
            gpsDeviceStorePath: USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH
          }),

          details: route => ({
            userStorePath: USERS_SEARCH_SELECTED_USER_STORE_PATH,
            userId: route.params.userId
          })
        },

        children: [
          {
            path: '/',
            name: 'userDetails',
            component: User,
            props: route => ({
              userStorePath: USERS_SEARCH_SELECTED_USER_STORE_PATH,
              selectedHuntAreaStorePath: USERS_SEARCH_SELECTED_USER_HUNT_AREA_STORE_PATH,
              selectedHuntStorePath: USERS_SEARCH_SELECTED_USER_HUNT_STORE_PATH,
              selectedGPSStorePath: USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
              usersCacheStorePath: USERS_CACHE_NAMESPACE,
              huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE,
              userId: route.params.userId
            })
          },
          {
            path: 'huntarea/:huntAreaId',
            component: HuntAreaModule,
            props: route => ({
              huntAreaStorePath: USERS_SEARCH_SELECTED_USER_HUNT_AREA_STORE_PATH,
              huntAreaId: route.params.huntAreaId
            }),

            children: [
              {
                path: '/',
                name: 'userDetailsHuntArea',
                component: UserHuntArea,
                props: route => ({
                  huntAreaStorePath: USERS_SEARCH_SELECTED_USER_HUNT_AREA_STORE_PATH,
                  huntAreaId: route.params.huntAreaId,
                  usersCacheStorePath: USERS_CACHE_NAMESPACE,
                  huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE
                })
              }
            ]
          },
          {
            path: 'hunt/:huntId',
            component: HuntModule,
            props: route => ({
              huntStorePath: USERS_SEARCH_SELECTED_USER_HUNT_STORE_PATH,
              huntId: route.params.huntId
            }),

            children: [
              {
                path: '/',
                name: 'userDetailsHunt',
                component: UserHunt,
                props: route => ({
                  huntStorePath: USERS_SEARCH_SELECTED_USER_HUNT_STORE_PATH,
                  huntId: route.params.huntId,
                  usersCacheStorePath: USERS_CACHE_NAMESPACE
                })
              }
            ]
          },
          {
            path: 'gps/:deviceId',
            component: GPSDeviceModule,
            props: route => ({
              gpsDeviceStorePath: USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
              deviceId: route.params.deviceId
            }),

            children: [
              {
                path: '/',
                name: 'userDetailsGPS',
                component: UserGPS,
                props: route => ({
                  userStorePath: USERS_SEARCH_SELECTED_USER_STORE_PATH,
                  weHuntGPSStorePath: USERS_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
                  gpsDeviceStorePath: USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
                  usersCacheStorePath: USERS_CACHE_NAMESPACE,
                  deviceId: route.params.deviceId
                })
              }
            ]
          },
          {
            path: 'wehuntgps/:imei',
            component: WeHuntGPSModule,
            props: route => ({
              weHuntGPSStorePath: USERS_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
              imei: route.params.imei
            }),

            children: [
              {
                path: '/',
                name: 'userDetailsWeHuntGPS',
                component: UserWeHuntGPS,
                props: route => ({
                  weHuntGPSStorePath: USERS_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
                  gpsDeviceStorePath: USERS_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
                  usersCacheStorePath: USERS_CACHE_NAMESPACE,
                  imei: route.params.imei
                })
              }
            ]
          }
        ]
      },
      {
        path: 'gps',
        name: 'gpsDevicesSearch',
        components: {
          master: GPSDevicesSearch
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedWeHuntGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
            selectedGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE
          })
        }
      },
      {
        path: 'wehuntgps/:imei',
        components: {
          master: GPSDevicesSearch,
          details: WeHuntGPSModule
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedWeHuntGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
            selectedGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE
          }),

          details: route => ({
            weHuntGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
            imei: route.params.imei
          })
        },
        children: [
          {
            path: '/',
            name: 'wehuntGPSDetails',
            component: WeHuntGPS,
            props: route => ({
              weHuntGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
              gpsDeviceStorePath: GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
              usersCacheStorePath: USERS_CACHE_NAMESPACE,
              imei: route.params.imei
            })
          }
        ]
      },
      {
        path: 'gps/:deviceId',
        components: {
          master: GPSDevicesSearch,
          details: GPSDeviceModule
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedWeHuntGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
            selectedGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE
          }),

          details: route => ({
            gpsDeviceStorePath: GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
            deviceId: route.params.deviceId
          })
        },
        children: [
          {
            path: '/',
            name: 'gpsDetails',
            component: GPSDevice,
            props: route => ({
              gpsDeviceStorePath: GPS_DEVICES_SEARCH_SELECTED_GPS_DEVICE_STORE_PATH,
              weHuntGPSStorePath: GPS_DEVICES_SEARCH_SELECTED_WEHUNT_GPS_DEVICE_STORE_PATH,
              usersCacheStorePath: USERS_CACHE_NAMESPACE,
              weHuntGPSRouteName: 'wehuntGPSDetails',
              deviceId: route.params.deviceId
            })
          }
        ]
      },
      {
        path: 'huntareas',
        name: 'huntAreasSearch',
        components: {
          master: HuntAreasSearch
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedHuntAreaStorePath: HUNT_AREAS_SEARCH_SELECTED_HUNT_AREA_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE,
            huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE
          })
        }
      },
      {
        path: 'huntareas/:huntAreaId',
        components: {
          master: HuntAreasSearch,
          details: HuntAreaModule
        },
        props: {
          master: route => ({
            query: route.query.q,
            selectedHuntAreaStorePath: HUNT_AREAS_SEARCH_SELECTED_HUNT_AREA_STORE_PATH,
            usersCacheStorePath: USERS_CACHE_NAMESPACE,
            huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE
          }),

          details: route => ({
            huntAreaStorePath: HUNT_AREAS_SEARCH_SELECTED_HUNT_AREA_STORE_PATH,
            huntAreaId: route.params.huntAreaId
          })
        },
        children: [
          {
            path: '/',
            name: 'huntAreaDetails',
            component: HuntArea,
            props: route => ({
              huntAreaStorePath: HUNT_AREAS_SEARCH_SELECTED_HUNT_AREA_STORE_PATH,
              usersCacheStorePath: USERS_CACHE_NAMESPACE,
              huntAreaId: route.params.huntAreaId,
              huntAreasCacheStorePath: HUNT_AREAS_CACHE_NAMESPACE
            })
          }
        ]
      },
      {
        path: 'gamecams',
        name: 'gamecamsSearch',
        components: {
          master: GamecamsSearch
        },
        props: {
          master: route => ({
            query: route.query.q,
            gamecamStorePath: GAMECAMS_SEARCH_STORE_NAMESPACE
          })
        }
      },
      {
        path: 'gamecams/:email',
        components: {
          master: GamecamsSearch,
          details: GamecamModule
        },
        props: {
          master: route => ({
            query: route.query.q,
            gamecamStorePath: GAMECAMS_SEARCH_STORE_NAMESPACE
          }),

          details: route => ({
            gamecamStorePath: GAMECAMS_SEARCH_STORE_NAMESPACE,
            email: route.params.email
          })
        },
        children: [
          {
            path: '/',
            name: 'gamecamDetails',
            component: Gamecam,
            props: route => ({
              gamecamStorePath: GAMECAMS_SEARCH_STORE_NAMESPACE,
              email: route.params.email
            })
          }
        ]
      }
    ]
  },
  {
    path: '/ads',
    component: Ads,

    children: [
      {
        path: '',
        name: 'adsSidebar',
        components: {
          master: AdsSidebar
        },

        props: {
          master: {
            adsStorePath: ADS_STORE_NAMESPACE
          }
        }
      },
      {
        path: ':adId',
        name: 'adDetails',
        components: {
          master: AdsSidebar,
          details: AdDetails
        },

        props: {
          master: {
            adsStorePath: ADS_STORE_NAMESPACE
          },
          details: route => ({
            adsStorePath: ADS_STORE_NAMESPACE,
            adId: route.params.adId
          })
        }
      }
    ]
  },
  ...animalsRoutes,
  ...resourcesRoutes,
  {
    path: '*',
    component: PageNotFound
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
